// extracted by mini-css-extract-plugin
export default {"activityBanner":"index_activityBanner_DmHBQ","activityBannerImg":"index_activityBannerImg_B6alt"};